import _pickBy from 'lodash/pickBy';

export const teleshoppingSanitizer = values => {
  const {
    contract,
    verification_sale,
    observations,
    price,
    instalments,
    process,
    unmaterializedVoucherProcessId,
    salesmanId,
    voucherSerial
  } = values;

  const sanitizedFilters = {
    contract_id: contract,
    verification_sale_id: verification_sale,
    process,
    salesman_id: salesmanId
  };

  if (observations) {
    sanitizedFilters[observations] = observations;
  }

  if (!!price && !!instalments) {
    sanitizedFilters['price'] = price;
    sanitizedFilters['instalments'] = instalments;
  }

  if (unmaterializedVoucherProcessId) {
    sanitizedFilters[
      'unmaterialized_process_id'
    ] = unmaterializedVoucherProcessId;
  }

  if (voucherSerial) {
    sanitizedFilters['voucher_serial'] = voucherSerial;
  }

  const params = _pickBy(
    sanitizedFilters,
    filter => !!filter || filter === false
  );
  return {
    ...params
  };
};
